import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Image = ({ link, src, alt, png,style, ...props }) => {
  const [loaded, setLoaded] = useState(false);
 //https://cannabition-staging.firebaseapp.com
  const imgPath = `https://cannabition-staging.firebaseapp.com/images/${png ? 'png' : 'jpg'}/${src}.${png ? 'png' : 'jpg'}`;

  return (
    <div style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.6s ease-in-out', height: '100%' }}>
      <LazyLoadImage
        afterLoad={() => {
				  setLoaded(true);
        }}
        effect="opacity"
        className={props.className || ''}
        src={link || imgPath}
        style={{ objectFit: 'cover',...style }}
        height={props.height || '100%'}
        width={props.width || '100%'}
        alt={alt}
        {...props}
      />
    </div>
  );
};

export default Image;
